module.exports = __webpack_public_path__ + "img/cat_header.412d6d2e.svg";